import React from 'react';
import { Content } from './shared';

const AetnaGymMembership = () => (
  <Content>
    Did you know working out is considered preventative care? Find a list of participating gyms on
    the Aetna website.
    <ol>
      <li>Log into your Aetna account to access Lifemart.</li>

      <li>Go to Wellness {'>'} Gyms.</li>

      <li>Browse gyms and click View Deal to sign up.</li>
    </ol>
  </Content>
);

export default AetnaGymMembership;
